import { useTheme } from '@emotion/react';
import React from 'react';

import { Box, Text } from '~/components/blocks';

import { GoogleReCaptcha } from '../GoogleReCaptcha';

export const PatientGoogleReCaptcha = () => {
  const theme = useTheme();

  return (
    <>
      <GoogleReCaptcha />
      <Box textAlign="center" margin={`${theme.space.l} ${theme.space.m} ${theme.space.xl}`}>
        <GoogleReCaptcha.Policy />
        <Text size="xs" marginTop={theme.space.l}>
          &copy;2020 MEDLEY, INC.
        </Text>
      </Box>
    </>
  );
};
